<template>
    <div class="simple">
        <div class="content">
            <img class="lotto-logo" src="/static/img/lotto-logo.png" />

            <div class="center-content">
                <slot></slot>
            </div>

            <img v-if="$route.fullPath !== '/'" class="main-logo" src="/static/img/main-logo.png" />
        </div>
        <footer>
            <div class="copy" v-if="$route.fullPath !== '/game'">
                <img class="stl-logo" src="/static/img/footer.png" />
                <p class="disclaimer">Voor het organiseren van Lotto is aan Lotto bv vergunning verleend door de Kansspelautoriteit, trekking Laan van Hoornwijck 55 te Rijswijk.<br />
    Deelname vanaf 18 jaar. Als je aan deze actie meedoet, dan accepteer je onze <a href="/static/pdf/lotto_actievoorwaarden.pdf?v3" target="_blank">actievoorwaarden</a>. | <a href="https://www.nederlandseloterij.nl/privacy" target="_blank">Privacy Statement</a> Nederlandse Loterij</p>
            </div>
            <div v-else>
                <v-prize-display></v-prize-display>
            </div>
        </footer>
    </div>
</template>

<style lang="scss" scoped>
    .lotto-logo{
        z-index:3;

        &.extended{
            position:relative;
        }
    }
</style>

<script>
    import PrizeDisplay from '@/app/components/PrizeDisplay';

    export default {
        components: {
            'v-prize-display': PrizeDisplay
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/layouts/Simple.vue